// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
import QuoteAccordion from '../ui-helper-elements/QuoteAccordion'
import MonthlyDiscountsSection from './MonthlyDiscountsSection'
import OneTimeDiscountsSection from './OneTimeDiscountsSection'
// JS Imports
// Asset Imports

export default function OtherOptionsSection() {
   const state = useQuoteContext()
   const displaySectionPermissions =
      state.featurePermissions['OneTimeProductTable']

   if (state.user_view == 'External')
      return (
         <QuoteAccordion
            accordionName='Other Options'
            accordionBodyId='otherOptionsAccordion'
            collapse={state.user_view == 'External' ? 'true' : 'false'}
         >
            <MonthlyDiscountsSection></MonthlyDiscountsSection>
            <OneTimeDiscountsSection></OneTimeDiscountsSection>
         </QuoteAccordion>
      )
   else
      return (
         <div>
            <MonthlyDiscountsSection></MonthlyDiscountsSection>
            {displaySectionPermissions.includes(state.user_role) && (
               <OneTimeDiscountsSection />
            )}
         </div>
      )
}
